import { createRoute, redirect } from '@tanstack/react-router';
import { Route as pathlessAuthenticatedRoute } from '../../route';

// TEMPORARY redirect — remove after all tenants migrate to OMS v3.
// The OMS v3 review page moved to /sales-orders/$draftId; stale approval-email
// links must keep working. `search: true` preserves tab/rail/pipeline state.
// The v3 detail components still live in this folder (imported by the
// /sales-orders/$draftId route module).
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/sales-orders-v3/$draftId',
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/sales-orders/$draftId', params, search: true });
  },
});
